import React from "react";

const FORA_LOGO_URL =
    "https://customer-assets.emergentagent.com/job_fora-progress-report/artifacts/h3j5wwqy_image.png";

/**
 * FORA logo
 * - variant="image" → uses the official FORA brand asset (recommended on light bg)
 * - variant="wordmark" → CSS-built wordmark with red dot (works on any bg, used on dark bg)
 */
export const ForaLogo = ({
    size = "1.75rem",
    color = "currentColor",
    variant = "wordmark",
    className = "",
    ...rest
}) => {
    if (variant === "image") {
        return (
            <img
                src={FORA_LOGO_URL}
                alt="FORA"
                className={`block ${className}`}
                style={{ height: size, width: "auto" }}
                data-testid="fora-logo"
                {...rest}
            />
        );
    }
    return (
        <span
            className={`fora-wordmark ${className}`}
            style={{ fontSize: size, color }}
            data-testid="fora-logo"
            aria-label="FORA"
            {...rest}
        >
            <span>F</span>
            <span className="dot" aria-hidden="true" />
            <span>RA</span>
        </span>
    );
};

export default ForaLogo;
